import React from 'react';
import { FileText, MapPin, SpinnerGap, MagnifyingGlass, Eye } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { getStatusColor, getStatusIcon } from './OverviewTab';

export default function ApplicationsTab({ loadingApps, applications, navigate }) {
  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">My Applications</h2>
        <div className="flex gap-2">
          <Button variant="outline" size="sm">All</Button>
          <Button variant="outline" size="sm">Pending</Button>
          <Button variant="outline" size="sm">Accepted</Button>
        </div>
      </div>
      {loadingApps ? (
        <div className="flex items-center justify-center py-12">
          <SpinnerGap size={48} weight="bold" className="animate-spin text-[#2B4C6F]" />
        </div>
      ) : applications.length === 0 ? (
        <div className="text-center py-12">
          <FileText size={64} weight="light" className="text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No Applications Yet</h3>
          <p className="text-gray-500 mb-4">Start applying to jobs to see them here</p>
          <button onClick={() => navigate('/browse-jobs')} className="h-14 px-6 bg-[#2B4C6F] text-white font-bold rounded-xl border-2 border-black shadow-[3px_3px_0px_#000] hover:shadow-[4px_4px_0px_#000] active:translate-y-1 active:shadow-none transition-all">
            <MagnifyingGlass size={20} weight="bold" className="inline mr-2" />
            Browse Jobs
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {applications.map((app) => (
            <div key={app._id} className="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{app.job_title || 'Job Application'}</h3>
                  <p className="text-gray-600">{app.job_company || 'Company'}</p>
                  {app.job_location && (
                    <p className="text-sm text-gray-500 flex items-center mt-1">
                      <MapPin size={16} weight="bold" className="mr-1" />
                      {app.job_location}
                    </p>
                  )}
                </div>
                <Badge className={`${getStatusColor(app.status)} px-3 py-1`}>
                  <span className="flex items-center gap-1">
                    {getStatusIcon(app.status)}
                    {app.status.charAt(0).toUpperCase() + app.status.slice(1)}
                  </span>
                </Badge>
              </div>
              {app.proposed_rate && (
                <p className="text-sm text-gray-600 mb-2">
                  <strong>Proposed Rate:</strong> {app.proposed_rate}
                </p>
              )}
              <div className="flex items-center justify-between">
                <p className="text-sm text-gray-500">
                  Applied {new Date(app.created_at).toLocaleDateString()}
                </p>
                <div className="flex space-x-2">
                  <Button size="sm" variant="outline" onClick={() => navigate(`/job/${app.job_id}`)}>
                    <Eye size={16} weight="bold" className="mr-2" />
                    View Job
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
